import _get from 'hs-lodash/get';
import Raven from 'raven-js';
import { isKnownError } from './errors';
import { isAcceptanceTestOrDev } from './general';
const captureException = error => {
  const message = _get(error, 'message', '');
  const status = _get(error, 'status');
  const isSentryEventHandled = _get(error, 'responseJSON.sentryEventSent', false);
  if (isKnownError(message, status) || isSentryEventHandled) return;
  if (!isAcceptanceTestOrDev) {
    Raven.captureException(error, {
      extra: {
        message
      }
    });
  } else {
    console.error(`error timestamp: ${new Date().toISOString()}`);
    console.error(error);
  }
};
export default captureException;